import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { runCommand as run } from '@wix/package-manager';

export const skillsUpdateCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  const args = ['--yes', 'skills', 'update'] as const;

  /**
   * Test-only escape hatch:
   * The CLI driver runs the CLI through `fnm exec`, which can rewrite PATH.
   * In tests we want deterministic interception of `npx` without relying on PATH
   * ordering, so we allow overriding the executable via env var.
   */
  const npxExecutable = process.env.WIX_CLI_NPX_PATH ?? 'npx';

  return createCommand('update')
    .description('Update installed skills to the latest version')
    .action(async (_, command) => {
      const { runCommand } = await import('./render-command.js');

      await runCommand(command, services, cliVersion, async (model) => {
        try {
          await run(`${npxExecutable} ${args.join(' ')}`, {
            cwd: model.projectFolder,
            output: process.stdout,
          });
        } catch (e) {
          throw new CliError({
            code: CliErrorCode.FailedToRunExternalCommand({
              file: 'npx',
              args: [...args],
            }),
            cause: e,
          });
        }
      });
    });
};
